/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import {SeekBarLabel} from 'bitmovin-player-ui';

function findOrNull(fn) {
    return () => {
        if (typeof fn !== 'function') {
            return null;
        }
        try {
            const result = fn();
            if (typeof result === 'string' && result !== '') {
                return result;
            }
            return null;
        } catch (e) {
            return null;
        }
    };
}

export class BitmovinSpriteSeekBarLabel extends SeekBarLabel {
    constructor(config = {}) {
        const {spriteThumbnailUrlCallback, ...seekBarLabelConfig} = config;
        super(seekBarLabelConfig);
        this.spriteThumbnailUrlCallback = findOrNull(spriteThumbnailUrlCallback);
    }

    setThumbnail(thumbnail = null) {
        if (thumbnail === null || thumbnail === undefined) {
            super.setThumbnail(null);
            return;
        }
        const spriteThumbnailUrl = this.spriteThumbnailUrlCallback();
        super.setThumbnail({
            ...thumbnail,
            url: spriteThumbnailUrl ?? thumbnail.url
        });
    }
}
